import { z } from 'zod';

export const cardsControllerUpdatePathParamsSchema = z.object({
  id: z.string().uuid(),
});

export const cardsControllerUpdate200Schema = z.boolean();

export const cardsControllerUpdate400Schema = z.union([
  z.object({
    statusCode: z.enum(['400']),
    message: z.string(),
    type: z.enum(['InvalidData']),
    details: z.object({
      location: z.enum(['path', 'query', 'body']),
      explanation: z.object({
        issues: z.array(
          z
            .object({
              code: z.enum([
                'invalid_type',
                'invalid_literal',
                'custom',
                'invalid_union',
                'invalid_union_discriminator',
                'invalid_enum_value',
                'unrecognized_keys',
                'invalid_arguments',
                'invalid_return_type',
                'invalid_date',
                'invalid_string',
                'too_small',
                'too_big',
                'invalid_intersection_types',
                'not_multiple_of',
                'not_finite',
              ]),
              path: z.array(z.union([z.string(), z.number()])),
              message: z.string(),
            })
            .catchall(z.unknown()),
        ),
      }),
    }),
  }),
  z.object({
    statusCode: z.enum(['400']),
    message: z.string(),
    type: z.enum(['ForeignViolation']),
    details: z.object({ attributes: z.array(z.string()) }),
  }),
]);

export const cardsControllerUpdate401Schema = z.object({
  statusCode: z.enum(['401']),
  message: z.string(),
  type: z.enum(['Authentication']),
  details: z.object({
    reason: z.enum(['InvalidRequest', 'InvalidToken', 'Unauthorized']),
  }),
});

export const cardsControllerUpdate403Schema = z.object({
  statusCode: z.enum(['403']),
  message: z.string(),
  type: z.enum(['Authorization']),
  details: z.object({ reason: z.enum(['InsufficientScope']) }),
});

export const cardsControllerUpdate404Schema = z.object({
  statusCode: z.enum(['404']),
  message: z.string(),
  type: z.enum(['ObjectNotFound']),
  details: z.enum(['null']).nullable(),
});

export const cardsControllerUpdateMutationRequestSchema = z.object({
  title: z.string().min(3).max(255).optional(),
  content: z.string().optional().nullable(),
  contentImage: z.string().optional().nullable(),
  contentDetails: z.string().optional().nullable(),
  isActive: z.boolean().default(false).optional(),
});

export const cardsControllerUpdateMutationResponseSchema = z.boolean();
